import { render, staticRenderFns } from "./researchList.vue?vue&type=template&id=e7adba9e&scoped=true&"
import script from "./researchList.vue?vue&type=script&lang=js&"
export * from "./researchList.vue?vue&type=script&lang=js&"
import style0 from "./researchList.vue?vue&type=style&index=0&id=e7adba9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7adba9e",
  null
  
)

export default component.exports